import {
    Ecommerce,
    EventNamesList,
    Taxonomy,
    TrackingContract,
    Baselayer
} from './contracts';
import snakeCase from 'lodash/snakeCase';
import { mapTraitsToTaxonomy } from './segment/mapTraitsToTaxonomy';

const snakeCaseKeys = <T extends Record<string, unknown>>(obj: T) =>
    Object.entries(obj).reduce<T>(
        (acc, [key, value]) => ({
            ...acc,
            ...{ [snakeCase(key)]: value }
        }),
        {} as T
    );

export const mapTracking = (
    taxonomy?: Taxonomy,
    ecommerce?: Ecommerce
): TrackingContract | null => {
    if (typeof window === 'undefined' || !window.analytics) {
        return null;
    }

    const baselayer: Baselayer = {
        session_id: window.__global_base_session_id,
        instance_id: window.__global_base_instance_id,
        device_id: window.__global_base_device_id,
        session_count: window.__global_base_session_count,
        event_id:
            typeof crypto !== 'undefined' && 'randomUUID' in crypto
                ? crypto.randomUUID()
                : undefined
    };

    const eventData: TrackingContract = {
        baselayer,
        ecommerce
    };

    if (taxonomy) {
        eventData.taxonomy = snakeCaseKeys({
            ...taxonomy,
            path: window.location.pathname
        });
    }
    if (ecommerce) {
        eventData.ecommerce = snakeCaseKeys({
            ...ecommerce
        });
    }

    return eventData;
};

export type TrackSegmentFunction = (
    eventName: EventNamesList,
    taxonomy?: Taxonomy,
    ecommerce?: Ecommerce
) => void;

/**
 * @deprecated Replaced by trackSegmentAndGAEvent.
 */
export const trackEvent: TrackSegmentFunction = async (
    eventName: EventNamesList,
    taxonomy?: Taxonomy,
    ecommerce?: Ecommerce
) => {
    const eventData = mapTracking(taxonomy, ecommerce);

    if (!eventData) return;

    if (typeof window.analytics !== 'undefined') {
        window.analytics.ready(() => {
            const traits = window.analytics?.user().traits();
            window.analytics?.track(
                eventName,
                {
                    ...eventData,
                    taxonomy: {
                        ...eventData.taxonomy,
                        ...mapTraitsToTaxonomy(traits)
                    }
                },
                { traits }
            );
        });
    }
};
